import React from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';

class MobileView extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  render() {
    let backgroundSrc = {backgroundImage: 'url("' + this.props.introBackground + '")'};

    let mobileModal = (
      <div className="mobile-modal">
        <div className="mobile-modal__body text-center d-flex flex-column justify-content-center">
          <div className="mobile-modal__header text-center">
            <p className="font--large">
              {this.props.wallConfig.mobile_title}
            </p>
          </div>
          <h3>
            {this.props.wallConfig.mobile_content}
          </h3>

          <a href={this.props.wallConfig.mobile_landing_url} className="text-center btn btn--large btn--secondary">{this.props.wallConfig.mobile_button_text}</a>
        </div>
      </div>
    )

    return(
      <div className="container-fluid image-wall image-wall--mobile d-block d-lg-none d-xl-none">
        <div className="row h-100">
          <div className="background-column h-100 w-100">
            <div className="col-12 p-0 h-100 image-wall-mobile__background" style={backgroundSrc}>
              {mobileModal}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  wallConfig: state.wallConfig
})

const mapDispatchToProps = {
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileView);
